import { render, staticRenderFns } from "./ButtonIconText.vue?vue&type=template&id=15e60459&scoped=true&lang=pug"
import script from "./ButtonIconText.vue?vue&type=script&lang=ts"
export * from "./ButtonIconText.vue?vue&type=script&lang=ts"
import style0 from "./ButtonIconText.vue?vue&type=style&index=0&id=15e60459&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e60459",
  null
  
)

export default component.exports